<template>
    <div :class="'full-screen-booster-opening'+(boosterCards.length > 0 || isLoading ? ' visible' : '')" v-if="boosterCards.length > 0 || isLoading">
        <div class="text-center" v-if="!boosterCards.length">
            <loading-spinner/>
        </div>

        <div class="booster-wrapper" v-if="boosterCards.length">
            <div class="card-stack booster-pack-preshow" v-if="!showCards">
                <div class="pokemon-card booster-pack-shot" id="booster-pack-shot" ref="cardRefs" v-on:click="removePackshot()" v-on:contextmenu.prevent="removePackshot()">
                    <img v-if="inventoryItemToOpen" :src="inventoryItemToOpen?.asset_url" alt="packshot"/>
                </div>
            </div>

            <div class="card-stack booster-card-stack" v-show="showCards" id="booster-card-stack">
                <div v-for="(card, cardIndex) in boosterCards" :key="cardIndex" class="pokemon-card"
                     ref="cardRefs"
                     @touchstart="handleTouchStart" @touchmove="handleTouchMove"
                     @touchend="handleTouchEnd" @mousedown="handleMouseDown"
                     @mousemove="handleMouseMove" @mouseup="handleMouseUp"
                     @dragstart="handleDragStart" @contextmenu="handleContextMenu"
                    v-on:contextmenu="moveToNextCard(event)">
                    <img :src="getCardImageUrl(card)" alt="Card image" v-on:load="card.imageLoaded = true"/>
                </div>
            </div>
        </div>


        <div v-if="boosterCards.length > 0 && showCards" class="card-opening-footer bg-dark text-light p-2">
            <div class="w-100 current-card-info ps-1" v-if="visibleCardFromStack">
                <div class="price-display ml-1">
                    <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon" title="Currency">
                    {{ getCardPrice(visibleCardFromStack) }}
                </div>

                <a href="javascript:" class="card-opening-action-button" v-on:click="toggleAutoSlide()" v-if="cardsLeft !== 0">
                    <span v-if="!autoSlideInterval" class="mb-1 badge rounded-pill bg-black text-white">{{ $t('boosters.auto') }} <i class="fa-solid fa-play"></i></span>
                    <span v-else class="mb-1 badge rounded-pill bg-black text-white">{{ $t('boosters.stop') }} <i class="fa-solid fa-stop"></i></span>
                </a>

                <a href="javascript:" class="card-opening-action-button mb-1 badge rounded-pill bg-black text-white" v-on:click="skipCardOpening">
                    <i class="fa-solid fa-fast-forward"></i> {{ $t('boosters.skip') }}
                </a>
            </div>

            <div class="cards-left-display mb-1 mt-1 px-2">
                <span class="mr-1 text-center">
                    <span>{{ cardsLeft }}</span><br/>
                    {{ $t('boosters.cardsLeft') }}
                </span>

                <img src="/assets/dipocaco/icons/new.webp" class="new-marker" alt="new marker" v-if="!collectedIds.includes(visibleCardFromStack.id)">

                <img :src="setLogo" style="height: 3.5em;" class="float-right mb-1 ml-3 set-logo" alt="set logo"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CardService from "../../CardService.js";
import LoadingSpinner from "./LoadingSpinner.vue";

export default {
    name: "BoosterPullDisplay",
    components: {LoadingSpinner},
    props: {
        inventoryItemToOpen: Object,
        openMultiple: 0
    },
    data() {
        return {
            boosterCards: [],
            pulledCards: [],
            // setLogo: '',
            cardsLeft: -1,
            startX: 0,
            startY: 0,
            initialX: 0,
            initialY: 0,
            currentCard: null,
            cardRemovalTimeout: 333,
            showCards: false,
            isLoading: false,
            autoSlideInterval: null,
            autoSlideSpeed: 1400,
            collectedIds: [],
        };
    },
    computed: {
        visibleCardFromStack() {
            return this.cardsLeft >= 0 ? JSON.parse(this.boosterCards[this.cardsLeft].json) : false;
        },
        allCardsLoaded() {
            return this.boosterCards.length > 0
                && [ ... document.querySelectorAll('.pokemon-card img') ].filter(img => !img.complete).length === 0;
        },
        setLogo() {
            if (this.visibleCardFromStack) {
                return '/assets/dipocaco/sets/'+this.visibleCardFromStack.set.id+'/logo.png';
            } else {
                return '/assets/dipocaco/sets/base1/logo.png';
            }
        }
    },
    mounted() {
        document.addEventListener("keyup", (e) => {
            if (e.key === "ArrowUp" && this.cardsLeft >= 0 && this.showCards) {
                this.moveToNextCard();
            }

            if (this.cardsLeft >= 0 && !this.showCards) {
                this.removePackshot();
            }
        });
    },
    watch: {
        inventoryItemToOpen(inventoryItem, previousValue) {
            if (previousValue === null) {
                this.isLoading = true;
                this.openBoosterPack(inventoryItem);
            }
        },
        openMultiple(value, previousValue) {
            if (value > 0) {
                this.isLoading = true;
                this.openMultiplePacks(value);
            }
        },
        allCardsLoaded(value, previousValue) {
            if (value === true) {
                if (this.openMultiple > 0) {
                    this.$emit('cardsloaded', true)
                    this.isLoading = false;
                    this.currentCard = document.querySelector('.card-stack');

                    setTimeout(() => {
                        this.removePackshot();
                    }, 400)
                } else {
                    this.$emit('cardsloaded', true)
                    this.isLoading = false;
                    this.currentCard = document.querySelector('.card-stack');
                }
            }
        }
    },
    methods: {
        removePackshot() {
            document.getElementById('booster-pack-shot').classList.add('clicked');

            setTimeout(() => {
                this.showCards = true
            }, 600);

            setTimeout(() => {
                document.getElementById('booster-card-stack').classList.add('now-visible');
            }, 650);
        },
        openMultiplePacks() {
            this.showCards = false;
            this.pulledCards = [];

            document.getElementById('booster-pack-shot')?.classList?.remove('clicked');
            document.getElementById('booster-card-stack')?.classList?.remove('now-visible');

            axios.get('/api/pack/multiple/'+this.openMultiple).then((response) => {
                CardService.sortCardsByRarity(Object.values(response.data)).reverse().forEach(newCard => this.boosterCards.push(newCard));

                this.cardsLeft = this.boosterCards.length - 1;
                this.currentCard = document.querySelector('.card-stack');

                this.$store.commit('updateUserInventory')
                this.loadCollectedIds();
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
        },
        openBoosterPack(inventoryItem) {
            this.showCards = false;
            this.pulledCards = [];

            document.getElementById('booster-pack-shot')?.classList?.remove('clicked');
            document.getElementById('booster-card-stack')?.classList?.remove('now-visible');

            let itemToOpen = Object.assign(inventoryItem);
            inventoryItem.opening = true;

            axios.get('/api/pack/' + itemToOpen.id).then((response) => {
                CardService.sortCardsByRarity(Object.values(response.data)).reverse().forEach(newCard => this.boosterCards.push(newCard));
                Object.assign(this.pulledCards, this.boosterCards);

                this.cardsLeft = this.boosterCards.length - 1;
                // this.setLogo = `https://images.pokemontcg.io/${itemToOpen.set_id}/logo.png`;
                this.$store.commit('updateUserInventory')
                this.loadCollectedIds();
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
        },
        skipCardOpening() {
            this.boosterCards = [];
            this.cardsLeft = 0;
            this.$emit('boosterOpeningFinished', this.pulledCards);
        },
        toggleAutoSlide() {
            if (this.autoSlideInterval) {
                window.clearInterval(this.autoSlideInterval);
                this.autoSlideInterval = null;
            } else {
                this.autoSlideInterval = setInterval(() => {
                    if (this.cardsLeft > 0) {
                        this.moveToNextCard();
                    } else {
                        window.clearInterval(this.autoSlideInterval);
                        this.autoSlideInterval = null;
                    }
                }, this.autoSlideSpeed)
            }
        },
        getCardImageUrl(card) {
            return CardService.getCardImageUrl(JSON.parse(card.json));
        },
        getCardPrice(card) {
            return CardService.getPrice(card);
        },
        getRarityIcon(card) {
            return CardService.getRarityIcon(card);
        },
        markCardAsLoaded(card) {
            card.imageLoaded = true;
            // this.$forceUpdate;
        },
        removeTopCard() {
            this.cardsLeft--;
            this.boosterCards.pop();

            if (this.cardsLeft === -1) {
                this.$emit('boosterOpeningFinished', this.pulledCards);
            }
        },
        moveToNextCard(event = null) {
            if (event) {
                event.preventDefault();
            }

            if (!this.currentCard) {
                this.currentCard = document.querySelector('.card-stack').lastElementChild;
            }

            this.currentCard.style.transition = 'transform 1s ease, opacity 1s ease';
            this.currentCard.style.transform = `translateY(-1000px)`;
            this.currentCard.style.opacity = '0';
            this.currentCard = null;

            setTimeout(() => {
                this.removeTopCard();
            }, this.cardRemovalTimeout);
        },
        handleTouchStart(e) {
            this.startX = e.touches[0].clientX;
            this.startY = e.touches[0].clientY;
            this.initialX = this.startX;
            this.initialY = this.startY;
            this.currentCard = e.target.closest('.pokemon-card');
        },
        handleTouchMove(e) {
            if (!this.currentCard) return;

            let dy = e.touches[0].clientY - this.initialY;

            if (dy < 0) {
                this.currentCard.style.transform = `translateY(${dy}px)`;
            }
        },
        handleTouchEnd(e) {
            if (!this.currentCard) return;

            let endY = e.changedTouches[0].clientY;

            if (this.startY - endY > 100) {
                this.moveToNextCard();
            } else {
                this.currentCard.style.transition = 'transform 0.5s ease';
                this.currentCard.style.transform = `translateY(0)`;
                this.currentCard = null;
            }
        },
        handleMouseDown(e) {
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.initialX = this.startX;
            this.initialY = this.startY;
            this.currentCard = e.target.closest('.pokemon-card');
        },
        handleMouseMove(e) {
            if (!this.currentCard) return;

            let dy = e.clientY - this.initialY;

            if (dy < 0) {
                this.currentCard.style.transform = `translateY(${dy}px)`;
            }
        },
        handleMouseUp(e) {
            if (!this.currentCard) return;

            let endY = e.clientY;
            if (this.startY - endY > 100) {
                this.currentCard.style.transition = 'transform 1s ease, opacity 1s ease';
                this.currentCard.style.transform = `translateY(-1000px)`;
                this.currentCard.style.opacity = '0';

                setTimeout(() => {
                    this.removeTopCard();
                }, this.cardRemovalTimeout);
            } else {
                this.currentCard.style.transition = 'transform 0.5s ease';
                this.currentCard.style.transform = `translateY(0)`;
            }

            this.currentCard = null;
        },
        handleDragStart(e) {
            e.preventDefault();
            return false
        },
        handleContextMenu(e) {
            e.preventDefault();
            return false
        },
        loadCollectedIds() {
            axios.get('/api/user/collected-ids').then(response => {
                this.collectedIds = Object.values(response.data);
                this.boosterCards = this.boosterCards.map((card) => {
                    card.is_in_set_collection = this.collectedIds.includes(card.card_id) === false;
                    return card;
                });

                Object.assign(this.pulledCards, this.boosterCards);
            });
        }
    },
};
</script>


<style scoped lang="scss">
.card-stack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.full-screen-booster-opening {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 500;

    background-color: rgba(0, 0, 0, 0.5);
    padding: 2em;

    .booster-wrapper {
        margin: 2em auto;
        position: relative;
        display: block;
        max-height: 80vh;
        text-align: center;

        .pokemon-card {
            top: 0;
            width: 100%;
            position: absolute;
            height: auto;
            transition: transform 0.5s ease, opacity 0.5s ease;

            img {
                min-width: auto;
                min-height: auto;
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 80vh;
                border-radius: 25px;
            }
        }

        .booster-pack-shot img {
            border-radius: 0;
        }

        .booster-pack-shot {
            transition: transform 0.5s ease, opacity 0.5s ease;
        }

        .booster-pack-shot.clicked {
            transform: scale(2.5);
            opacity: 0;
        }

        .booster-card-stack {
            transform: scale(2.5);
            opacity: 0;
            transition: transform 0.5s ease, opacity 0.5s ease;
        }

        .booster-card-stack.now-visible {
            opacity: 1;
            transform: scale(1);
        }

        .pokemon-card:last-child img,
        .pokemon-card:nth-child(2) img,
        .pokemon-card:first-child img {
            -webkit-box-shadow: 10px 10px 44px 0px rgba(0, 0, 0, 0.75);
            -moz-box-shadow: 10px 10px 44px 0px rgba(0, 0, 0, 0.75);
            box-shadow: 10px 10px 44px 0px rgba(0, 0, 0, 0.75);
        }

        .booster-info {
            z-index: 500;
            margin-top: 80vh;
            position: relative;

            img {
                max-height: 10em;
            }
        }
    }
}

.card-opening-footer {
    position: fixed;
    bottom: 0;
    z-index: 500;
    left: 0;
    right: 0;
    width: 100vw;
    background-color: white;
    filter: drop-shadow(2px 4px 6px black);
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;

    .current-card-info {
        display: flex;
        font-size: 2em;
        justify-content: space-between;
        align-items: center;

        .price-display {
            margin-right: .33em;
            display: flex;
            align-items: center;
        }

        .currency-icon {
            height: 1.25em;
            margin-right: .33em;
        }
    }

    .cards-left-display {
        display: flex;
        align-items: flex-end;
        flex-direction: row;
        justify-content: space-between;

        .badge {
            text-align: center;
            padding: 1em;

            span {
                font-size: 2em;
            }
        }

        .set-logo {
            max-width: 25vw;
        }
    }

    .card-opening-action-button {
        margin-left: 1em;
        margin-right: 1em;
        //padding: 1.5em 2.7em;
        text-decoration: none;
    }

    .new-marker {
        height: 2.7em;
        display: inline-block;
    }
}
</style>
